import React from "react"
import Grid from "@mui/material/Grid";
import CCOCard from "../../fundamentals/CCOCard";
import {SosDonationProductType} from "../../types";
import ProductTeaserCardContent from "./ProductTeaserCardContent";
import useWindowSize from "../../../utility/useWindowSize";


export interface Props {
    borderWidth?: string,
    customStyle?: any,
    horizontal?: boolean,
    item: SosDonationProductType,
    padding?: number,
    itemCount: number,
    headlineType?: string,
    descriptionCharLimit?: number,
    isPageView?: boolean,
    suppressRoofline?: boolean
}

/**
 * Wird beim Rendern der Suchlistenansicht verwendet
 */
function C085ProductTeaser(props: Props) {
    const md = props.itemCount && props.itemCount < 2 ? 12 : 6;
    const lg = (props.itemCount && props.itemCount < 3) ? props.itemCount < 2 ? 12 : 6 : 4;
    const padding = props.padding ? props.padding : 0;
    const {lowerThanWindowLarge} = useWindowSize();
    const isHorizontal = (props.itemCount < 2) && !lowerThanWindowLarge;

    if (!props.item) {
        return null;
    }
    const noLink = !props.item.teaserTarget || props.isPageView || props.suppressRoofline;
    return <Grid key={"grid" + props.item.id} size={{xs: 12, md: md, lg: lg}}>
        <CCOCard dataCypress={"teaserCard"}
                 customStyle={props.customStyle}
                 item={props.item}
                 key={"card-" + props.item.id}
                 padding={padding}
                 isTargetCMDownload={false}
                 noLink={noLink}
                 hasFocusedStyle={!props?.suppressRoofline}
                 teasercardLocation="CO85 Product-Teaser">
            <ProductTeaserCardContent item={props.item}
                                      horizontal={isHorizontal}
                                      key={"card-content-" + props.item.id}
                                      descriptionCharLimit={props.descriptionCharLimit}
                                      isPageView={props.isPageView}
                                      suppressRoofline={props.suppressRoofline}
                                      suppressCTA={noLink}/>
        </CCOCard>
    </Grid>
}

export default C085ProductTeaser